import { TreeNode } from "@/types/tree";
import { getPathsToImageControls } from "./controls";
import { BatchRequest } from "../api/api";
import { jsonStringifyOrUndefined } from "@/util/json-stringify-or-undefined";
import { ioTsToOpenAiJsonSchemaResponseFormatValue } from "@/subapps/onboarding/lib/ai";
import { KeywordsForImageInNodeResponseV, SimplifiedTreeNodeForLLM } from "./types";
import { globalStore } from "@/store/store";

// we should simplify it further to make what we pass to the LLM shorter - this will result in a faster response from the LLM
export function simplifyTreeNodeForLLM(node: TreeNode): SimplifiedTreeNodeForLLM {
  return {
    nodeType: node.data.type,
    nodeId: String(node.id),
    content: node.data.properties?.content || {},
    children: node.children.length > 0 
      ? node.children.map(child => simplifyTreeNodeForLLM(child))
      : undefined
  };
}

export function generateImageKeywordsPrompt(section: TreeNode): string {
  const simplifiedSection = simplifyTreeNodeForLLM(section);
  const imageControls = getPathsToImageControls(section);
  const businessName = globalStore.aiSettings.prompt.businessName;
  const businessDescription = globalStore.aiSettings.prompt.businessDescription;
  
  return `Based on the following website section structure, please provide search keywords for the images at the specified control paths.

Website Context:
- Business Name: ${businessName}
- Business Description: ${businessDescription}

Section structure:
${jsonStringifyOrUndefined(simplifiedSection)}

Image controls to populate:
${imageControls.map(control => `- NODEID: ${control.nodeId}, CONTROLPATH: ${control.controlPath}`).join('\n')}

For each control path, analyze the surrounding content (headings, text, context) AND the business context to determine what the image should represent. The keywords should be relevant to the business type and industry described above.

For example, if this is a dog walking service and there's a "booking" section, use keywords like "dog walking booking", "pet care appointment", "dog walker schedule" rather than generic "booking" or "appointment" keywords.

It's important you return the exact control path specified by me, and the exact node id specified by me (it follows NODEID: - ignore any other id keys in teh provided JSON, and the controlpath that follows CONTROLPATH:)

`;
}

export function createImageKeywordsBatchRequest(section: TreeNode): BatchRequest {
  const prompt = generateImageKeywordsPrompt(section);
  
  return {
    id: `image-keywords-${section.id}`,
    messages: [
      {
        role: "user",
        content: prompt
      }
    ],
    responseFormat: ioTsToOpenAiJsonSchemaResponseFormatValue(
      KeywordsForImageInNodeResponseV, 
      "image_keywords_schema"
    )
  };
}